function useNetworkInfo() {
  return null;
}

export default useNetworkInfo;
